import { render, staticRenderFns } from "./BenefitEventsTable.vue?vue&type=template&id=74555646&"
import script from "./BenefitEventsTable.vue?vue&type=script&lang=js&"
export * from "./BenefitEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports